import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Error from "../assets/images/error.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "450px",
  minWidth: "300px",
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  background: "#ffffff",
  padding: "40px 0px",
};

const ModalText = styled.h1`
  width: 70%;
  margin: 30px auto 0 auto;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
  text-align: center;
  @media screen and (max-width: 577px) {
    width: 90%;
  }
`;

const ModalButton = styled.button`
  background-color: #fed743;
  border-radius: 0;
  border: 3px solid #000;
  height: 47px;
  padding: 0 10px;
  cursor: pointer;
  a {
    color: white;
    text-decoration: none;
    font-weight: 500;
  }
`;
const CloseButton = styled.button`
  height: 46px;
  display: flex;
  align-items: center;
  border-radius: 0;
  border: 3px solid black;
  color: white;
  background: #c5cede;
  font-weight: 400;
  box-shadow: none;
  font-weight: 500;
  padding: 0 15px;
  cursor: pointer;
`;

function WhitelistModal({ message, isError, onCloseModal }) {
  const { t } = useTranslation();
  return (
    <Modal
      open={isError}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <img src={Error} alt="" style={{ width: "90px", margin: "0 auto" }} />
          <ModalText>{message}</ModalText>
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              gap: "20px",
              align: "center",
              justifyContent: "center",
            }}
          >
            <CloseButton onClick={onCloseModal}>
                {t("close")}
            </CloseButton>
            <ModalButton>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScJxgsObGgrK4zM6_UDtYSHIOTbF9xpNRz3ciLQZhJR6Cm5nQ/viewform"
                target="_blank"
                rel="noreferrer"
              >
                {t("sign_up_to_test")}
              </a>
            </ModalButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default WhitelistModal;
